import React, {Fragment} from 'react';
import styles from "./buyRecomendation.module.scss";
import {useTranslation} from 'react-i18next';
import {v4 as uuidv4} from "uuid";
import {
    IAnalytics, IDiversificationGroupsByTickers, IInfoAboutAdviceToAnalyticsPopup, IStrategiesInfo,
    IToOrder,
    RecommendationLabel,
    StateOfTrade,
    StateOfTradeLabel,
    TimeFrames,
    TimeFramesLabel, TradeAction, UserRoles
} from "../../../../shared/types";
import {Button} from "antd";
import advisor from "../../../../assets/images/advisor.png"

interface Props {
    strategiesInfo: IStrategiesInfo | undefined,
    recomends: Record<TradeAction, Partial<Record<string, [string[]]>>>
    strategy: string
    btnRequestLoading: boolean
    registerRequestHandler: (request: IToOrder) => {}
    analytics: IAnalytics | undefined
    showAnalytics: (request: IInfoAboutAdviceToAnalyticsPopup) => void
    typeOfBuyRecomendation: StateOfTrade
    diversificationGroupsByTickers?: IDiversificationGroupsByTickers
}

const BuyRecomendation = ({strategiesInfo, recomends, strategy, btnRequestLoading, registerRequestHandler, analytics, showAnalytics, typeOfBuyRecomendation, diversificationGroupsByTickers}: Props) => {

    const {t, i18n} = useTranslation();

    if (!strategiesInfo) {
        return null
    }

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <p
                    className={styles.strategyTitle}
                    title={strategiesInfo[strategy]?.description}>
                    <img src={advisor} alt="advisor"/>
                    {/*//@ts-ignore*/}
                    {t('AdvisorsOrderStrategy')}
                    - <span>{strategiesInfo[strategy].label}</span>
                </p>
                {recomends.BUY[strategy]?.map((elem) => {
                    if (elem[2] === typeOfBuyRecomendation) {
                        const price = elem[5]
                        const date = elem[6]
                        const stopLoss = elem[7]
                        const takeProfit = elem[8]
                        const diversificationGroup = typeOfBuyRecomendation === StateOfTrade.NEED_OPEN_SERIES
                            ? diversificationGroupsByTickers?.recommendations[elem[0]]
                            : undefined
                        const groupAlreadyOpened = Boolean(diversificationGroup && diversificationGroupsByTickers?.openedPositions && Object.values(diversificationGroupsByTickers.openedPositions).includes(diversificationGroup))
                        return <Fragment key={uuidv4()}>
                            <p className={styles.tickerTitle}>
                                {elem[0]}
                            </p>
                            {diversificationGroup && <p className={[styles.otherTitle, groupAlreadyOpened ? styles.groupInOpenedPositions : ''].join(' ')}>
                                {/*//@ts-ignore*/}
                                {t('AdvisorsOrderDiversificationGroup')} - {diversificationGroup}
                            </p>}
                            <p className={styles.otherTitle}>
                                {/*//@ts-ignore*/}
                                {t('AdvisorsOrderTimeframe')} - {TimeFramesLabel[elem[1] as TimeFrames]}
                            </p>
                            <p className={styles.otherTitle}>
                                {/*//@ts-ignore*/}
                                {t('AdvisorsOrderAction')} - {t(RecommendationLabel.BUY)} / {t(StateOfTradeLabel[elem[2] as StateOfTrade])}
                            </p>
                            {/*//@ts-ignore*/}
                            <p className={styles.otherTitle}>{t('AdvisorsOrderSpecificities')} - {elem[4]}</p>
                            <p className={styles.otherTitle}
                                /*//@ts-ignore*/
                               title={t('AdvisorsOrderVolumeDescription')}
                            >
                                {/*//@ts-ignore*/}
                                {t('AdvisorsOrderVolume')} - {elem[3]}
                            </p>
                            {/*//@ts-ignore*/}
                            <p className={styles.otherTitle}>{t('AdvisorsOrderPrice')} - {price}</p>
                            <p className={styles.otherTitle}>stop-loss - {stopLoss}</p>
                            <p className={styles.otherTitle}>take-profit - {takeProfit}</p>
                            <div className={styles.btns}>
                                <div className={styles.btnRequest}>
                                    <Button size={'small'} shape={'round'} loading={btnRequestLoading}
                                            onClick={() => registerRequestHandler({
                                                strategy: strategy,
                                                ticker: elem[0],
                                                timeframe: elem[1] as TimeFrames,
                                                price: price.toString(),
                                                stopLoss: stopLoss.toString(),
                                                takeProfit: takeProfit.toString(),
                                                date: date,
                                                actionType: TradeAction.BUY,
                                                action: elem[2] as StateOfTrade,
                                                value: Number(elem[3]),
                                                specificity: elem[4]
                                            })}>
                                        {/*//@ts-ignore*/}
                                        {t('AdvisorsOrderSubmitOrder')}
                                    </Button>
                                </div>
                                <div className={styles.btnAnalytics}>
                                    <Button size={'small'} shape={'round'} type={'primary'}
                                            onClick={() => showAnalytics({
                                                ticker: elem[0],
                                                specificity: elem[4]
                                            })}
                                            disabled={!analytics || !analytics.news[elem[0]]}
                                    >
                                        {/*@ts-ignore*!*/}
                                        {t('AdvisorsOrderViewAnalytics')}
                                    </Button>
                                </div>
                            </div>
                        </Fragment>
                    }
                })}
            </div>
        </div>
    );
};

export default BuyRecomendation;
